/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IUpdateProfileMethods,
  UpdateProfileService,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  IMyProfileCardMethods,
  MyProfileCardService
} from "./components";

export type MyProfilePageAgent = IHeaderMethods &
  IUpdateProfileMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IMyProfileCardMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new UpdateProfileService(),
    new StaticPageContentService(),
    new LoadingService(),
    new MyProfileCardService()
  ];
};

export const getAgent = () => {
  return createAgent<MyProfilePageAgent>({
    plugins: getPlugins(),
  });
};
